export default __webpack_public_path__ + "static/media/photo_right_2.5a34da27.png";